import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m12.25 12.75-3.5-3.5m1.167-2.917a4.083 4.083 0 1 1-8.167 0 4.083 4.083 0 0 1 8.167 0"
    }, null, -1)
  ]))]))
}
export default { render: render }